/* istanbul ignore file @preserve -- client app file does not need to be tested. */ import { parseClientAppConfig } from '@ori/client-app-config';
import { outdatedBrowserInfo } from '@ori/outdated-browser-info';
export var render = function(rootElement) {
    var _rootElement_dataset = rootElement.dataset, _rootElement_dataset_config = _rootElement_dataset.config, config = _rootElement_dataset_config === void 0 ? '' : _rootElement_dataset_config;
    var outdatedBrowserInfoConfig = parseClientAppConfig(config, [
        'tenant',
        'staticApiUrl'
    ]);
    if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_USE_REQUESTLY === '1') {
        // eslint-disable-next-line no-console -- we need to log this info
        console.log('USING REQUESTLY');
    }
    outdatedBrowserInfo(outdatedBrowserInfoConfig);
};
